import { render, staticRenderFns } from "./consumptions_history.vue?vue&type=template&id=18d3249a&lang=pug&"
import script from "./consumptions_history.vue?vue&type=script&setup=true&lang=js&"
export * from "./consumptions_history.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./consumptions_history.vue?vue&type=style&index=0&id=18d3249a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports